"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

require("core-js/modules/es6.regexp.search");

require("core-js/modules/web.dom.iterable");

var _toConsumableArray2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray"));

var _moment = _interopRequireDefault(require("moment"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// secondary package based on el-pagination
// Custom Table Column Mixins (Omega Theme)
// const rules = {
//   roleName: [
//     { required: true, message: "Please input a role name", trigger: "blur" }
//   ]
// };
var treeProps = {
  children: "childs",
  label: "title"
};
var _default = {
  name: "role:view",
  mixins: [_CustomTableColumn.default],
  permission: "roleManagement",
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  data: function data() {
    return {
      viewOnly: false,
      paginationOptions: {
        page: 1,
        limit: 10
      },
      showDialog: false,
      tree: [],
      tableData: [],
      totalData: 0,
      search: "",
      formData: {
        roleId: []
      },
      formTitle: "",
      formButton: "",
      rules: {
        roleName: [{
          required: true,
          message: this.$t('system.role.roleName') + this.$t('SMS.canNotBeEmpty'),
          trigger: "blur"
        }]
      },
      treeProps: treeProps,
      toBeDelete: null,
      loading: true,
      scraped: [],
      toBeUncheck: [],
      toBeCheck: [],
      monitor: false,
      disableChange: false
    };
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    scraping: function scraping(permission) {
      var _this2 = this;

      var perms = (0, _toConsumableArray2.default)(permission);
      perms.forEach(function (perm) {
        if (perm.childs.length) {
          _this2.scraping(perm.childs);
        } else {
          _this2.scraped.push(perm.data.menuId);
        }
      });
    },
    fetchData: function fetchData() {
      var _this3 = this;

      var _this = this;

      _this.loading = true;

      _httpUtils.default.post("role", "list", null, {
        pageNum: _this.paginationOptions.page,
        pageSize: _this.paginationOptions.limit,
        roleName: _this.search
      }).then(function (res) {
        if (res.code == 200) {
          _this.tableData = res.data.rows;
          _this.totalData = res.data.total;
        } else {
          _this.$notify({
            title: _this3.$t("common.error"),
            message: _this3.$t("common.fetchError"),
            type: "error"
          });
        }

        _this.loading = false;
      }).catch(function (err) {
        _this.$notify({
          title: _this3.$t("common.error"),
          message: _this3.$t("SMS.error") + ',' + err.message,
          type: "error"
        });

        _this.loading = false;
      });

      _httpUtils.default.post("menu", "tree", null, {}).then(function (res) {
        if (res.code == 200) {
          _this.tree = res.data;
        }
      }).catch(function (err) {
        _this.$notify({
          title: _this3.$t("common.error"),
          message: _this3.$t("SMS.error") + ',' + err.message,
          type: "error"
        });
      });
    },
    addData: function addData(data) {
      var _this = this;

      _httpUtils.default.post("role", "add", null, data).then(function (res) {
        if (res.code == 200) {
          _this.fetchData();

          _this.closeDialog();

          _this.$notify({
            title: _this.$t("common.success"),
            message: _this.$t("system.role.createRoleText1"),
            type: "success"
          });
        } else {
          _this.$notify({
            title: _this.$t("common.error"),
            message: +res.message,
            type: "error"
          });
        }
      }).catch(function (err) {
        _this.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    updateData: function updateData(data) {
      var _this = this;

      _httpUtils.default.post("role", "update", null, data).then(function (res) {
        if (res.code == 200) {
          _this.fetchData();

          _this.closeDialog();

          _this.$notify({
            title: _this.$t("common.success"),
            message: _this.$t("system.role.editRoleText2"),
            type: "success"
          });
        } else {
          _this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch(function (err) {
        _this.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    deleteData: function deleteData(data) {
      var _this = this;

      _httpUtils.default.post("role", "delete", null, data).then(function (res) {
        if (res.code == 200) {
          _this.fetchData();

          _this.$notify({
            title: _this.$t("common.success"),
            message: _this.$t("system.role.deleteRoleText4"),
            type: "success"
          });
        } else {
          _this.$notify({
            title: _this.$t("common.error"),
            message: res.message,
            type: "error"
          });
        }
      }).catch(function (err) {
        _this.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    handleSearch: function handleSearch() {
      this.paginationOptions.page = 1;
      this.paginationOptions.limit = 10;
      this.fetchData();
    },
    handleDialog: function handleDialog(cmd, id) {
      var _this4 = this;

      this.initForm(cmd);

      if (cmd == "view") {
        this.viewOnly = true;
        this.fillForm(id);
      }

      if (cmd == "edit") this.fillForm(id);
      this.$nextTick(function () {
        _this4.showDialog = true;

        _this4.$nextTick(function () {
          _this4.$refs.tree.setCheckedKeys(_this4.formData.menuIds);

          _this4.monitor = true;
        });
      });
    },
    handlePagination: function handlePagination(newOptions) {
      var _this5 = this;

      this.paginationOptions = newOptions;
      this.$nextTick(function () {
        return _this5.fetchData();
      });
    },
    handleSubmit: function handleSubmit() {
      var _this6 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          var dummy = (0, _objectSpread2.default)({}, _this6.formData);

          var checked = _this6.$refs.tree.getCheckedKeys();

          var halfChecked = _this6.$refs.tree.getHalfCheckedKeys();

          checked = checked.concat(halfChecked);
          dummy.menuIds = checked.join(",");

          _this6.$nextTick(function () {
            if (dummy.roleId) {
              _this6.updateData(dummy);
            } else {
              _this6.addData(dummy);
            }
          });
        }
      });
    },
    handleDelete: function handleDelete(roleIds) {
      var _this7 = this;

      this.$confirm(this.$t("system.role.deleteRoleText3"), this.$t("common.warning"), {
        confirmButtonText: this.$t("common.delete"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      }).then(function () {
        return _this7.deleteData([roleIds]);
      }).catch(function () {
        return null;
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.toBeDelete = val;
    },
    handleMultipleDelete: function handleMultipleDelete() {
      var _this8 = this;

      var temp = this.toBeDelete;

      if (!temp) {
        this.$notify({
          title: this.$t("common.error"),
          message: this.$t("system.role.deleteRoleText1"),
          type: "error"
        });
        return;
      }

      var roleIds = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = temp[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var data = _step.value;
          roleIds.push(data.roleId);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$confirm(this.$t("system.role.deleteRoleText3"), this.$t("common.warning"), {
        confirmButtonText: this.$t("common.delete"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      }).then(function () {
        return _this8.deleteData(roleIds);
      }).catch(function () {
        return null;
      });
    },
    handleCheck: function handleCheck(node, _ref) {
      var _this9 = this;

      var checkedKeys = _ref.checkedKeys;
      var status = checkedKeys.includes(node.data.menuId.toString());

      if (!status && node.childs.length && this.monitor) {
        this.toBeUncheck.push(parseInt(node.data.menuId));
        this.uncheckChilds(node.childs);
        this.$nextTick(function () {
          var _form = (0, _objectSpread2.default)({}, _this9.formData);

          _form.menuIds = _form.menuIds.filter(function (menu) {
            return !_this9.toBeUncheck.includes(menu);
          });
          _this9.toBeUncheck = [];
          _this9.formData = _form;

          _this9.$refs.tree.setCheckedKeys(_this9.formData.menuIds);
        });
      }

      if (status && this.monitor) {
        this.toBeCheck.push(parseInt(node.data.menuId));
        this.checkChilds(node);
        this.checkParents(node);
        this.$nextTick(function () {
          var _form = (0, _objectSpread2.default)({}, _this9.formData);

          _this9.toBeCheck.forEach(function (key) {
            if (!_form.menuIds.includes(key)) {
              _form.menuIds.push(key);
            }
          });

          _this9.formData = _form;
          _this9.toBeCheck = [];

          _this9.$refs.tree.setCheckedKeys(_this9.formData.menuIds);
        });
      }
    },
    uncheckChilds: function uncheckChilds(childs) {
      var _this10 = this;

      childs.forEach(function (child) {
        _this10.toBeUncheck.push(parseInt(child.data.menuId));

        if (child.childs.length) _this10.uncheckChilds(child.childs);
      });
    },
    checkParents: function checkParents(node) {
      if (!node) return;
      this.toBeCheck.push(parseInt(node.parentId));
      var parentNode = this.findNodeById(this.tree, parseInt(node.parentId));
      this.checkParents(parentNode);
    },
    checkChilds: function checkChilds(node) {
      var _this11 = this;

      if (node.childs.length) {
        node.childs.forEach(function (child) {
          _this11.toBeCheck.push(parseInt(child.data.menuId));

          _this11.checkChilds(child);
        });
      }
    },
    findNodeById: function findNodeById(tree, id) {
      var result;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = tree[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var node = _step2.value;
          if (parseInt(node.data.menuId) == id) return node;

          if (node.childs.length) {
            result = this.findNodeById(node.childs, id);
            if (result) break;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return result;
    },
    initForm: function initForm(cmd) {
      if (cmd == "add") {
        this.formTitle = this.$t("system.role.createRole");
        this.formButton = this.$t("common.add");
      } else if (cmd == "edit") {
        this.formTitle = this.$t("system.role.editRoleText1");
        this.formButton = this.$t("common.edit");
      } else if (cmd == "view") {
        this.formTitle = this.$t("system.role.viewRole");
      }

      this.formData = {
        menuIds: []
      };
      this.viewOnly = false;
    },
    fillForm: function fillForm(id) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.tableData[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var data = _step3.value;

          if (data.roleId == id) {
            var menuIds = [];

            if (data.menuIds != null) {
              var menuIdsArray = data.menuIds.split(",");
              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = menuIdsArray[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var _id = _step4.value;
                  menuIds.push(parseInt(_id));
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }
            }

            this.formData = {
              roleId: data.roleId,
              roleName: data.roleName,
              remark: data.remark,
              menuIds: menuIds
            };
            return;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    closeDialog: function closeDialog() {
      var _this12 = this;

      this.showDialog = false;
      this.formData = {
        menuIds: []
      };
      this.$refs.tree.setCheckedKeys([]);
      this.monitor = false;
      this.$nextTick(function () {
        return _this12.$refs.dataForm.clearValidate();
      });
    },
    dateFormat: function dateFormat(date) {
      if (date == undefined) {
        return "";
      }

      return (0, _moment.default)(date).format("YYYY-MM-DD HH:mm:ss");
    }
  }
};
exports.default = _default;